import React from 'react';
import {
  CheckFilledIcon,
  MenuHorizontalIcon,
  SurgeOutlineIcon,
  UserAltIcon
} from 'cokitchen-icons';
import { Dropdown, DropdownItem, DropdownList, Input } from '@cokitchen/cokitchen-components';
import { ReactComponent as CommentIcon } from 'assets/icons/comment.svg';
import { ReactComponent as HeadsetIcon } from 'assets/icons/headset.svg';
import { IssueType } from 'models/issue.model';
import useRoleContext from 'contexts/role.context';
import { ENUM_ROLE } from '@cokitchen/cokitchen-auth';
import { getUserName } from 'utils/functions';

type Props = {
  issue: IssueType;
  setShowDetails: (item: boolean) => void;
  setShowEscalateModal: (item: boolean) => void;
  isComplete?: boolean;
  markIssue: () => void;
  openReview: () => void;
  handleMenuClick: () => void;
};
const IssueCardHeader = ({
  issue,
  isComplete,
  markIssue,
  openReview,
  handleMenuClick,
  setShowDetails,
  setShowEscalateModal
}: Props) => {
  const user_name = getUserName(issue.user);
  const cs_rep = getUserName(issue.assigned_rep);
  const { role } = useRoleContext();
  const DROPDOWN_LIST = [
    {
      icon: <CheckFilledIcon />,
      title: 'Mark as resolved',
      onClick: () => openReview?.(),
      className: 'text-green-5'
    },
    {
      icon: <SurgeOutlineIcon />,
      title: 'Escalate Issue',
      onClick: () => setShowEscalateModal(true),
      className: `${role === ENUM_ROLE.CS_SUPER_ADMIN ? 'hidden' : ''}`
    }
  ];
  return (
    <div className='grow  py-3 space-y-2'>
      <div className='flex border-b border-[#ECEDEF] pb-2 items-center gap-2 flex-wrap justify-between'>
        <div className='flex gap-2 items-center'>
          <h4
            role='button'
            className='font-medium  text-base cursor-pointer'
            onClick={() => {
              if (!issue.order_code) return;

              setShowDetails(true);
            }}>
            {issue.order_code || user_name}
          </h4>

          {!isComplete ? (
            <Input
              type='checkbox'
              readOnly
              checked={false}
              onChange={markIssue}
              className='scale-[90%] text-sm'
            />
          ) : (
            <div className='inline-flex items-center gap-1 rounded-2xl border border-green-5 text-xs py-1 px-3 bg-green-1 text-green-5'>
              Resolved
            </div>
          )}
        </div>

        <div className='flex text-[#3D3D3D] font-medium items-center gap-1 text-sm min-w-fit'>
          <HeadsetIcon />
          {cs_rep}
          {!isComplete && (
            <span onClick={(e) => e.stopPropagation()}>
              <Dropdown
                content={
                  <MenuHorizontalIcon
                    onClick={handleMenuClick}
                    className='bg-[#FEF0F2] w-7 h-7 p-[7px] rounded-full cursor-pointer transition-all duration-200 hover:bg-red-3'
                  />
                }>
                <DropdownList>
                  {DROPDOWN_LIST.map(({ icon, onClick, title, className }, i) => (
                    <DropdownItem
                      key={i}
                      className={`flex items-center text-gray-5 ${className}`}
                      onClick={() => onClick?.()}>
                      {icon}
                      <label className='ml-3'>{title}</label>
                    </DropdownItem>
                  ))}
                </DropdownList>
              </Dropdown>
            </span>
          )}
        </div>
      </div>
      <div className='space-y-2 py-3'>
        <div className='text-sm text-gray-8 flex items-center gap-2'>
          <UserAltIcon className='text-gray-4' />
          {user_name}
        </div>
        <div className='text-sm text-[#313030] flex items-center gap-2'>
          <CommentIcon className='text-gray-4' />
          <p className='w-[90%]'>{issue.feedback_summary || '--'}</p>
        </div>
      </div>
    </div>
  );
};

export default IssueCardHeader;
